export default {
  "homeScreen": {
    "farm": "Tambak",
    "label": "Pilih Tambak",
    "noFarm": "Tidak ada tambak",

    "fetchingData": "Sedang mengambil data...",
    "pleaseWait": "Mohon tunggu",
    "noConnection": "Tidak dapat menampilkan hasil.\nMohon periksa koneksi Anda dan refresh halaman",

    "emptyFarm": "Anda belum memiliki tambak",
    "emptyPond": "Anda belum memiliki kolam",
    "emptyCycle": "Anda belum memiliki siklus aktif",
    "createFarm": "Buat tambak",
    "createPond": "Buat kolam",
    "createCycle": "Mulai siklus",

    "predictionBiomass": "Estimasi Biomasa",
    "actualFeedAccumulation": "Total Pakan",
    "predictionSR": "Estimasi SR",
    "predictionPrice": "Nilai Jual",
    "predictionWeight": "Estimasi MBW",
    "from": "dari ",
    "activePonds": " kolam aktif",

    "disclaimer": "Estimasi tidak akurat. Lengkapi data pakan untuk meningkatkan akurasi estimasi",

    "monitoring": "Monitoring",
    "pond": "Kolam",
    "finance": "Keuangan",
    "price": "Harga",
    "news": "Kabar",
    "disease": "Penyakit",
    "asto": "Asto",
    "predictions": "Prediksi",
    "beta": "Beta",
    "autoFeeder": "Auto Feeder",
    "shrimpPrice": "Harga Udang",
    "seeAll": "Lihat Semua",
    "shrimpNews": "Kabar Udang",
    "appMenusTitle": "Coba Fitur Lainnya",
    "consultTitle": "Butuh Konsultasi?",
    "consultSubtitle": "Kini Anda dapat berkonsultasi seputar budidaya lewat aplikasi.",
    "consultButton": "Tanya Sekarang",
    "youtubeTutorial": "Lihat tutorial JALA App",
    "helpTutorial": "Pusat bantuan",
    "telegramTutorial": "Bergabung dengan grup Telegram kami",
    "bannerTitle": "Solusi Budidaya Udang Lainnya",
    "bottomTitle": "Tutorial bertambak dengan JALA App",
    "overview": "Overview",
    "partner": "Mitra JALA",
    "firstTooltip": "Lihat prediksi dari hasil input data yang Anda lakukan",
    "secondTooltip": "Kelola budidaya udang melalui menu ini",
    "thirdTooltip": "Lihat prediksi dari hasil input data yang Anda lakukan",
    "fourthTooltip": "Dapatkan informasi harga udang terbaru disini",
    "fifthTooltip": "Informasi kabar udang terbaru disini",
    "tooltipSkip": "Lewati",
    "tooltipNext": "Selanjutnya",
    "tooltipPrevious": "Sebelumnya",
    "notifications": "Notifikasi",
    "simulation": "Simulasi",
    "chemicalPredictions": "Prediksi Kimia",
    "predictions": "Prediksi",
    "newLabel": "Baru",
    "activity": "Aktivitas",

    "startCultivationTitle": "Kelola budidaya udang dengan Jala",
    "startCultivation": "Mulai Budidaya",

    "alertNoFarmTitle": "Buat tambak terlebih dahulu",
    "alertNoFarmDescription": "Fitur pencatatan cepat hanya dapat Anda akses bila sudah memiliki tambak.",
    "alertNoActiveCycleTitle": "Tidak ada siklus Aktif",
    "alertNoActiveCycleDescription": "Mulai siklus untuk bisa mencatatkan data baik sebelum tebar dan setelah tebar. Di akhir budidaya, tutuplah siklus setelah anda panen total.",
    "alertStartCultivationTitle": "Ubah tampilan ke mode budidaya",
    "alertStartCultivationDescription": "Untuk akses fitur budidaya, ubah pengaturan tampilan di menu: Akun - Bantuan - Personalisasi Tampilan - lalu pilih Kelola Budidaya.",

    "reminderActivity": "Ketuk untuk melengkapi aktivitas harian Anda",
    "pro": "Pro",

    "occupationModalTitle": "Halo {{user}}!",
    "occupationModalSubtitle": "Lengkapi data profil Anda untuk mendapatkan pengalaman yang lebih baik dengan aplikasi JALA",

    "offline": "Mode Offline"
  },

  "modelCreateScreen": {
    "areYouSure": "Apakah anda yakin?",
    "areYouSureYouWantToSomething": "Apakah anda yakin ingin %{something}?",

    "deleteSomething": "menghapus %{something}",
    "thisData": "data ini"
  },

  "farmCreateScreen": {
    "title": "Buat Tambak",

    "disconnectedModalTitle": "Anda Tidak Terhubung",
    "disconnectedModalSubtitle": "Aplikasi mendeteksi koneksi lemah, pastikan terhubung dengan Internet",
  },
  "farmEditScreen": {
    "title": "Pengaturan Tambak",
  },

  "pondCreateMultipleScreen": {
    "title": "Buat Kolam"
  },

  "cycleCreateMultipleScreen": {
    "title": "Mulai Siklus",

    "deleteCycle": "Hapus Siklus",
    "deleteCycleSubtitle": "Peringatan! Anda tidak akan bisa mengakses data siklus yang telah dihapus",
    "deleteCycleModalTitle": "Hapus Siklus",
    "deleteCycleModalSubtitle": "Apakah anda yakin akan menghapus siklus?",
  },

  "farmShrimpPriceCreateScreen": {
    "title": "Pengaturan Nilai Jual",
  },

  "overviewScreen": {
    "setting": "Pengaturan",
    "total": "Total",
    "average": "Rata-rata",
    "fromActivePonds": "dari %{count} kolam aktif",
    "disclaimer": "Lengkapi data pakan untuk meningkatkan akuransi estimasi."
  },
  "overviewTotalWeightPredictionListScreen": {
    "title": "Estimasi Biomasa",
  },
  "overviewHarvestAccumulationWeightActualListScreen": {
    "title": "Total Panen",
  },
  "overviewFeedAccumulationActualListScreen": {
    "title": "Total Pakan",
  },
  "overviewSurvivalRatePredictionListScreen": {
    "title": "Estimasi SR",
  },
  "overviewSellingPricePredictionListScreen": {
    "title": "Estimasi Nilai Jual",
    "source": "Sumber nilai jual: "
  },

  "shrimpPriceScreen": {
    "size": "Size",
    "close": "Tutup",
    "country": "Negara",
    "location": "Lokasi",
    "update": "Update Harga",
    "all": "Semua",
    "verified": "Terverifikasi",
    "unverified": "Tidak Terverifikasi",
    "supplier": "Supplier",
    "findLoc": "Cari Lokasi",
    "cancel": "Batal",
    "latest": "Terbaru",
    "week": "> 1 Minggu",
    "month": "> 1 Bulan",
    "createPrice": "Buat Harga Udang",
    "name": "Nama Anda",
    "phone": "Nomor HP",
    "species": "Spesies",
    "province": "Provinsi",
    "city": "Kota/Kabupaten",
    "next": "Selanjutnya",
    "save": "Simpan",
    "shrimpPriceList": "List Harga Udang",
    "createdAt": "Tanggal",
    "date": "Tanggal",
    "currency": "Mata Uang",
    "currencyId": "Mata Uang",
    "sizeInput": "Harga size",
    "remark": "Catatan (opsional)",
    "disclaimer": "Dengan ini saya bertanggung jawab atas informasi harga udang yang saya buat dan publikasikan di Jala",
    "size200": "Size 200",
    "size190": "Size 190",
    "size180": "Size 180",
    "size170": "Size 170",
    "size160": "Size 160",
    "size150": "Size 150",
    "size140": "Size 140",
    "size130": "Size 130",
    "size120": "Size 120",
    "size110": "Size 110",
    "size100": "Size 100",
    "size90": "Size 90",
    "size80": "Size 80",
    "size70": "Size 70",
    "size60": "Size 60",
    "size50": "Size 50",
    "size40": "Size 40",
    "size30": "Size 30",
    "size20": "Size 20",
    "size150Placeholder": "Isi harga",
    "size140Placeholder": "Isi harga",
    "size130Placeholder": "Isi harga",
    "size120Placeholder": "Isi harga",
    "size110Placeholder": "Isi harga",
    "size100Placeholder": "Isi harga",
    "size90Placeholder": "Isi harga",
    "size80Placeholder": "Isi harga",
    "size70Placeholder": "Isi harga",
    "size60Placeholder": "Isi harga",
    "size50Placeholder": "Isi harga",
    "size40Placeholder": "Isi harga",
    "size30Placeholder": "Isi harga",
    "size20Placeholder": "Isi harga",

    "datePlaceholder": "Pilih Tanggal",
    "remarkPlaceholder": "Contoh : Harga BS 60 % dari harga normal",
    "currencyPlaceholder": "Pilih...",
    "currencyIdPlaceholder": "Pilih...",
    "namePlaceholder": "Nama Anda",
    "phonePlaceholder": "Nomor HP",
    "speciesPlaceholder": "Pilih...",
    "countryPlaceholder": "Pilih...",
    "provincePlaceholder": "Pilih...",
    "provinceLabel": "Pilih Provinsi",
    "cityPlaceholder": "Pilih...",
    "sizePlaceholder": "Nominal",
    "partner": "Mitra JALA",
    "priceList": "Daftar Harga",
    "contact": "Kontak",
    "seeContact": "Hubungi",
    "anotherPrice": "Harga Daerah Lain",
    "implement": "Terapkan",

    "dateValidation": "Tanggal harus diisi",
    "currencyValidation": "Mata uang harus diisi",
    "sizeValidation": "Size 100 harus diisi",
    "phoneValidationLength": "Format nomor telepon tidak sesuai",
    "selectAll": "PILIH SEMUA"
  },
  "shrimpPriceListScreen": {
    "title": "Harga Udang",

    "listShrimpPrice": "List Harga Udang",
    "createPrice": "Buat Harga",
    "partner": "Mitra JALA",
    "listEmptyTitle": "Harga udang di lokasi yang anda cari tidak temukan.",
    "listEmptySubtitle": "Coba cari lokasi lain untuk menemukan harga udang.",
    "searchLocation": "Cari Lokasi",
  },
  "shrimpPriceDetailScreen": {
    "title": "Harga Udang",

    "unverified": "Tidak Terverifikasi",
    "verified": "Terverifikasi",
    "partner": "Mitra JALA",

    "contact": "Kontak",
    "seeContact": "Hubungi",

    "priceList": "Daftar Harga",
    "anotherPrice": "Harga Daerah Lain",
  },

  "waterQualityMultiMeasurementCreateScreen": {
    "title": "Tambah Data Kualitas Air"
  },
  "waterQualityMultiMeasurementEditScreen": {
    "title": "Ubah Data Kualitas Air"
  },
  "feedCreateScreen": {
    "title": "Tambah Data Pakan"
  },
  "feedEditScreen": {
    "title": "Ubah Data Pakan"
  },
  "feedingTrayControlCreateScreen": {
    "title": "Tambah Data Anco"
  },
  "feedingTrayControlEditScreen": {
    "title": "Ubah Data Anco"
  },
  "mortalityCreateScreen": {
    "title": "Tambah Data Kematian"
  },
  "mortalityEditScreen": {
    "title": "Ubah Data Kematian"
  },
  "chemicalMultiMeasurementCreateScreen": {
    "title": "Tambah Data Kimia"
  },
  "chemicalMultiMeasurementEditScreen": {
    "title": "Ubah Data Kimia"
  },
  "planktonMultiMeasurementCreateScreen": {
    "title": "Tambah Data Plankton"
  },
  "planktonMultiMeasurementEditScreen": {
    "title": "Ubah Data Plankton"
  },
  "microbiologyMultiMeasurementCreateScreen": {
    "title": "Tambah Data Mikrobiologi"
  },
  "microbiologyMultiMeasurementEditScreen": {
    "title": "Ubah Data Mikrobiologi"
  },
  "cycleDiseaseListScreen": {
    "seeRelatedDiseaseInfo": "Baca Info Penyakit Terkait"
  },
  "cycleDiseaseCreateScreen": {
    "title": "Tambah Pencatatan",
    "seeDiseaseInfo": "Lihat Info Penyakit"
  },
  "cycleDiseaseEditScreen": {
    "title": "Ubah Pencatatan",
    "seeDiseaseInfo": "Lihat Info Penyakit"
  },
  "cycleEditScreen": {
    "title": "Ubah Data Siklus"
  },

  "cycleHarvestListScreen": {
    "closeCycle": "Tutup Siklus"
  },

  "cycleCloseScreen": {
    "title": "Tutup Siklus"
  },
  "cycleCloseMultipleScreen": {
    "title": "Tutup Siklus"
  },
  "cycleGraphScreen": {
    "title": "Graph Siklus"
  },
  "financeScreen": {
    "title": "Keuangan",
    "ongoingFeatureTitle": "Jali sedang membuat sesuatu yang baru!",
    "ongoingFeatureSubtitle": "Terima kasih masih setia menggunakan JALA App. Fitur ini masih di masa pengembangan. Pengguna Siklus Pro tetap bisa menggunakan fitur keuangan di web-app.",
    "openWeb": "Buka Web App",
    "learnProCycle": "Pelajari Siklus Pro",
  },
  "simulationScreen": {
    "title": "Simulasi",
    "emptyTitle": "Belum ada simulasi",
    "emptySubtitle": "Simulasi yang Anda simpan,\nnantinya akan muncul disini.",
    "biomassHeader": "Biomassa (kg)",
    "priceHeader": "Total Harga",
    "createSimulation": "Buat Simulasi",
    "listTitle": "Daftar Simulasi",
    "totalSeed": "Jumlah tebar",
    "survivalRate": "Survival rate",
    "biomassEstimation": "Estimasi biomassa",
    "edit": "Ubah",
    "delete": "Hapus",
    "name": "Nama Simulasi",
    "wide": "Luas Kolam (m²)",
    "date": "Tanggal Tebar",
    "seed": "Jumlah Tebar",
    "periode": "Periode Panen",
    "maxBiomass": "Biomassa Maks (kg/m²)",
    "survival": "Target Survival Rate (%)",
    "size100": "Size di umur 100 hari (ekor/kg)",
    "feedPrice": "Harga Pakan Per-kg",
    "currency": "Mata Uang",
    "addPartial": "Tambah Rencana Parsial",
    "partialPlan": "Rencana Parsial",
    "age": "Umur (hari)",
    "percent": "Persen",
    "addPlan": "Tambah Rencana",
    "cancel": "Batal",
    "show": "Tampilkan",
    "inputTitle": "Isi Data Simulasi",
    "inputAge": "Isi umur",
    "inputPercent": "Isi persentase",
    "SimulationTabTitle": "Hasil Simulasi",
    "HarvestPriceDisclaimer": "Total harga panen masih kosong dikarenakan Tabel Harga belum terisi.",
    "inputPrice": "Isi Tabel Harga",
    "priceSimulation": "Simulasi Harga Udang",
    "locationDisclaimer": "Pilih lokasi yang sesuai untuk mendapatkan simulasi harga panen Anda.",
    "location": "Lokasi",
    "chooseLocation": "Pilih filter lokasi",
    "inputPriceTag": "Isi harga",
    "FeedTabTitle": "Proyeksi Pengeluaran Pakan",
    "FeedChartTitle": "Pakan (kg)",
    "FeedPerfectData": "Pakan SR 100% (kg)",
    "BiomassChartTitle": "Total Biomassa Hidup",
    "BiomassChartLegend": "Total Biomassa Hidup (ton)",
    "BiomassMaxPerArea": "Biomassa Maks per-area (ton)",
    "BiomassPerfectData": "Total Biomassa SR 100% (ton)",
    "FeedPriceTotal": "Total Harga Pakan",
    "seeFeedTab": "Lihat Tabel Pakan",
    "deleteTitle": "Hapus Simulasi?",
    "deleteSubtitle": "Yakin ingin menghapus {{simulation}}?",
    "namePlaceholder": "Simulasi {{date}}",
    "widePlaceholder": "1.000 m²",
    "seedPlaceholder": "100.000 ekor",
    "periodePlaceholder": "120 hari",
    "biomassPlaceholder": "1,2 kg/m²",
    "survialPlaceholder": "100%",
    "sizePlaceholder": "45",
    "feedPlaceholder": "Rp 15.000",
    "currencyPlaceholder": "Indonesia",
    "showPrice": "Lihat Harga",
    "save": "Simpan Simulasi",
    "searchSimulation": "Cari Daftar Simulasi...",
    "showBiomasstable": "Lihat Tabel Biomassa",
    "biomasAxisY": "Total Biomassa (ton)",
    "axisX": "Hari",
    "feedAxisY": "Konsumsi Pakan (kg)",
    "TotalHarvest": "Total Panen",
    "quantityShort": "Ekor",
    "HarvestTab": "Panen",
    "FeedTab": "Pakan",
    "BiomassTab": "Biomassa",
    "DateDOCHeader": "Tanggal (DoC)",
    "Size": "Size",
    "TotalBiomass": "Total biomassa (kg)",
  },
  "customFRScreen": {
    "title": "Atur Tabel FR",
    "create": "Buat tabel FR Anda",
    "here": "disini"
  },
  "parameterListScreen": {
    "title": "Daftar Parameter",
    "info": "Anda hanya dapat menampilkan maksimal 3 jenis parameter di aplikasi mobile Jala. Buka web-app Jala untuk fitur yang lebih lengkap.",
    "chemical": "Kimia",
    "plankton": "Plankton",
    "microbio": "Mikrobiologi"
  },
  "cycleToDoScreen": {
    "title": "Aktivitas Harian",
    "empty": "Belum ada aktivitas",
    "emptyFarm": "Fitur ini belum bisa diakses karena Anda belum mempunyai tambak",
    "emptyPond": "Fitur ini belum bisa diakses karena Anda belum mempunyai kolam",
    "emptyCycle": "Fitur ini belum bisa diakses karena Anda belum mempunyai siklus aktif",
    "infoTitle": "Aktivitas Harian",
    "info": "Kelola aktivitas pencatatan data budidaya seperti data pakan, kualitas air, perlakuan juga data budidaya lainnya secara mudah dengan fitur aktivitas harian. Proses pencatatannya semakin cepat tanpa takut terlewat, data budidaya lengkap, hasil prediksi budidaya semakin akurat.",
    "feeding": "Pemberian pakan",
    "measuring": "Pengecekan kualitas air",
    "treatment": "Pemberian perlakuan",
    "feeding_tray_control": "Pengecekan anco",
    "sampling": "Pengecekan sampling",
    "mortality": "Pencatatan kematian",
    "harvest_partial": "Panen parsial",
    "harvest_total": "Panen total",
    "inputDoc": "Isi rentang DoC",
    "until": "sampai",
    "addActivity": "Tambah Aktivitas",
    "addActivityNote": "Yakin ingin menambahkan pengecekan anco pada aktivitas harian?",
    "incomplete": "Belum Lengkap",
    "missed": "Terlewat",
    "complete": "Lengkap",
    "closed": "Siklus ditutup",
    "seeOthers": "Lihat Aktivitas Lainnya",
    "seeLess": "Lihat Sedikit",
    "changeActivityStatus": "Ubah Status Aktivitas",
    "setting": "Pengaturan Aktivitas",
    "changeStatus": "Ubah status",
    "saveSetting": "Simpan Pengaturan",
    "morningRecord": "Pengecekan pagi",
    "eveningRecord": "Pengecekan sore",
    "settingWarning": "Aktivitas yang dipilih akan tertampil pada halaman aktivitas harian Anda.",
    "settingTitle": "Tambah Aktivitas Harian",
    "rangeDoc": "Rentang DoC",
    "rangeDocMax": "Rentang DoC tidak lebih dari 130",
    "rangeDocFrom": "Dari DoC",
    "rangeDocTo": "Sampai DoC",
    "lessThan130": "Range {{field}} tidak boleh lebih dari 130",
    "emptySearchTitle": "Kolam tidak ditemukan",
    "emptySearchSubtitle": "Gunakan kata kunci pencarian yang lain untuk menemukan kolam yang Anda cari",
    "functionDescription": "Keterangan Fungsi",
    "infoDescription": "Panduan aktivitas harian",
    "refreshDescription": "Refresh data aktivitas harian",
    "searchDescription": "Kolom pencarian nama kolam",
    "incompleteDescription": "Aktivitas harian belum lengkap",
    "completeDescription": "Aktivitas harian sudah lengkap",
    "hiddenDescription": "Menyembunyikan aktivitas harian yang sedang tidak dilaksanakan",
    "changeStatusDescription": "Mengubah status aktivitas harian jika terdapat kesalahan",
    "settingDescription": "Menambah atau mengurangi aktivitas harian"
  },
  "chemicalParameterScreen": {
    "emptyHistoryParameterTitle": "Lengkapi Data Pencatatanmu",
    "emptyHistoryParameterMessage": "Agar bisa mengetahui prediksi kimia, Anda perlu mencatatkan data pakan dan parameter fisika (pH, salinitas, temperatur, DO).",
    "completeData": "Lengkapi Data",
    "emptyMessageNewUser": "Fitur ini belum bisa diakses karena Anda belum mempunyai siklus aktif.",
    "gotoProTitle": "Dapatkan perhitungan prediksi kimia dengan hanya mencatatkan data pakan dan kualitas air fisika (pH, salinitas, suhu, dan DO).",
    "gotoProMessage": "JALA membantu Anda memprediksi data kimia berdasarkan data yang Anda catat di aplikasi.",
    "buttonGotoPro": "Upgrade Sekarang",
    "lowAccuracyTitle": "Akurasi Prediksi Belum Optimal",
    "lowAccuracyMessage": "Lengkapi pencatatan data pakan dan\nparameter fisika (pH, salinitas, temperatur,\nDO).",
    "latestUpdateText": "Data terakhir {{date}}",
    "parameter": "Parameter",
    "estimateValueToday": "Estimasi (DoC {{age}})",
    "actualValueToday": "Actual (DoC {{age}})",
    "estimateValueDoC": "Estimasi Terakhir\n(DoC {{age}})",
    "week": "7 Hari",
    "month": "30 Hari",
    "cycle": "1 Siklus",
    "lowAccuracyPredictionMessage": "Lengkapi data pakan dan parameter Fisika (pH, Salinitas, Temperatur, DO) ",
    "emptyPredictionMessage": "Nilai prediksi kosong, Isi <b>data pakan</b> dan <b>parameter fisika</b> untuk menampilkan nilai prediksi kimia. ",
    "showDetail": "Lihat detail",
    "alkalinity": "Alkalinitas",
    "hardness": "Kesadahan",
    "otherParameter": "Parameter Lainnya",
    "carbonate": "CO³",
    "bicarbonate": "HCO³",
    "calcium": "Ca",
    "magnesium": "Mg",
    "ammonia": "Ammonia",
    "nitrite": "Nitrit",
    "nitrate": "Nitrat",
    "tom": "TOM",
    "total": "Total",
    "data": "Data",
    "readDescription": "Baca Penjelasan",
    "sendFeedback": "Beri Masukan",
    "beta": "Beta",
    "alertBeta": "Prediksi ini masih dalam tahap uji coba (beta)\n<description> atau <feedback>.",
    "titleBetaCard": "Dapatkan perhitungan prediksi kimia dengan hanya mencatatkan data pakan dan kualitas air fisika (pH, salinitas, suhu, dan DO).",
    "messageBetaCard": "Fitur ini masih dalam tahap pengujian dan hanya diakses terbatas. Jika Anda tertarik untuk mencoba dan memberikan masukan, ajukan diri Anda melalui tombol di bawah ini",
    "buttonBetaCard": "Ajukan Diri Menjadi Beta Tester",
    "titleBetaSheet": "Prediksi Parameter Kimia",
    "content1BetaSheet": "Dengan fitur ini Anda dapat memprediksi data kualitas air khusus nya parameter kimia dan dapat Anda gunakan sebagai media alternatif menentukan perlakuan yang tepat untuk selalu menjaga kestabilan kualitas air di kolam.",
    "content2BetaSheet": "Prediksi ini dapat tertampil ketika terdapat pencatatan data di aplikasi yang meliputi data kumulatif pakan dan kualitas air parameter fisika (pH, Salinitas, Temperatur, dan DO).",
    "content3BetaSheet": "Prediksi dibuat oleh mesin kecerdasan buatan yang mempelajari kondisi kualitas air, iklim, dan penginputan pakan dari berbagai data tambak budidaya udang di Indonesia.",
    "subtitle1BetaSheet": "Parameter apa saja yang bisa diprediksi?",
    "subtitle2BetaSheet": "Bagaimana fitur ini bekerja?",
    "subtitle3BetaSheet": "Bagaimana prediksi ini dibuat?",
    "note1BetaSheet": "Kami menyadari bahwa perhitungan ini masih membutuhkan penyempurnaan sehingga masukan dari Anda sangat berarti untuk kami.",
    "note2BetaSheet": "<b>Catatan:</b> Prediksi ini belum mempertimbangkan faktor lain seperti cuaca, warna air, siphon, dan lain-lain.",
    "emptyDataTitle": "Nilai Prediksi Tidak Tertampil",
    "emptyDataMessage": "Prediksi kimia akan tertampil jika tersedia data pencatatan pakan dan parameter fisika (pH, Salinitas, temperatur, DO) dengan minimal 3 hari terakhir",
    "emptyCycle": "Fitur ini belum bisa diakses karena Anda belum mempunyai siklus aktif."
  },
  "gotoJalaProScreen": {
    "buttonText": "JALA Apps Pro",
    "title": "Semakin Pro dengan\n",
    "description": "Kelola data budidaya dengan fitur lebih lengkap agar menjadi wawasan yang komprehensif dan bermanfaat.",
    "benefitTitle1": "Input Excel",
    "benefitDesc1": "Input data kolektif budidaya dalam format yang lebih familiar.",
    "benefitTitle2": "Manajemen Keuangan",
    "benefitDesc2": "Kelola dan pantau pemasukan dan pengeluaran tambak.",
    "benefitTitle3": "Stok Tambak",
    "benefitDesc3": "Kelola dan pantau kondisi stok barang tambak Anda.",
    "benefitTitle4": "Laporan Budidaya",
    "benefitDesc4": "Buat laporan budidaya otomatis dengan analisis yang lengkap.",
    "benefitTitle5": "Prediksi Kimia",
    "benefitDesc5": "Dapatkan prediksi data kimia dengan memanfaatkan teknologi AI.",
    "readMore": "Baca Selengkapnya di ",
    "urlJalaPro": "https://jala.tech/pro",
    "upgradeNow": "Upgrade Sekarang",
    "upgrade": "Upgrade",
  }
}
